import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_API_BASE_URL
const API_KEY: any = process.env.REACT_APP_API_KEY
export const REGISTER_URL = `${API_URL}/v1/ekyc/otp/verify`
export const RESENDOTP_URL = `${API_URL}/v1/ekyc/otp/resend`

export const otpVerify = async (data: any) => {
  const response = await axios.post(REGISTER_URL, data, {
    headers: {
      'x-api-key': API_KEY,
      'Access-Control-Allow-Origin': '*',
    },
  })
  return response.data
}

export const reSendOtp = async (data: any) => {
  const response = await axios.post(RESENDOTP_URL, data, {
    headers: {
      'x-api-key': API_KEY,
      'Access-Control-Allow-Origin': '*',
    },
  })
  return response.data
}
